// console.log(process.env);

export const IS_PROD = process.env.NODE_ENV === 'production';
